















































import { Component, Vue, Prop } from 'vue-property-decorator';

import { Info, ApiKey } from '@/types/core';

import tippy from 'tippy.js';

import VueError from '@/components/VueError.vue';
import GroupAccessView from '@/components/access/GroupAccessView.vue';

@Component({
  components:{
    VueError,
    GroupAccessView
  }
})
export default class ApiKeyRow extends Vue {

  @Prop({ default: {},  type: Object}) apiKey!: ApiKey;
  @Prop({ default: 0,  type: Number}) index!: number;

  // internal dependencies
  error:string = '';
  
  async mounted() {
    // nothing here yet
    tippy('[data-tippy-content]');
  }

  maskApiKey(apiKey:string):string {
    return apiKey.substring(0, 10) + "*****" + apiKey.substring(30);
  }

  // this is not super elegant but it works reliably
  async copyToClipboard(apiKey:string) {

    // @ts-ignore
    let ret = await this.$copyText(apiKey);

    const button = document.querySelector(`#api-key-${apiKey}`) as Element;
    
    // @ts-ignore
    let localTippy = button._tippy as any;

    localTippy.setContent('copied!');
    localTippy.show();

    setTimeout(() => localTippy.hide(), 2000);
    setTimeout(() => localTippy.setContent('copy to the clipboard'), 2500);
  }
}
